// extracted by mini-css-extract-plugin
module.exports = {"container":"IppicaNavHeader_container__LqSMh","button":"IppicaNavHeader_button__tM32d","text":"IppicaNavHeader_text__cJpFF","icon":"IppicaNavHeader_icon__WIwJk"};